export default __webpack_public_path__ + "static/media/B232.0ae92baf.png";